import React from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import MenuIcon from '@material-ui/icons/Menu';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import * as AuthActions from '../../store/actions/auth';
import { MainListItems, SecondaryListItems } from './listItems';

export const DRAWER_WIDTH_LG = 183;
export const DRAWER_WIDTH_XL = 195;
export const DRAWER_WIDTH_MD = 172;
export const DRAWER_WIDTH_SM = 162;

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: DRAWER_WIDTH_LG,
    [theme.breakpoints.up('xl')]: {
      width: DRAWER_WIDTH_XL,
    },
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(5),
    },
    [theme.breakpoints.up('xl')]: {
      width: theme.spacing(7),
    },
  },
}));

export default function SharedUserDrawer({ open, onOpen, onClose, showSecondaryList = true }) {
  const classes = useStyles();
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const dispatch = useDispatch();
  const [logoutAnchorEl, setLogoutAnchorEl] = React.useState(null);

  const handleLogout = async () => {
    try {
      await dispatch(AuthActions.logout());
    } catch (error) {
      dispatch({ type: AuthActions.LOGOUT });
    }
    window.location.replace('/');
  };

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
      }}
      open={open}
    >
      <Grid style={{ height: isXl ? 57 : 50, backgroundColor: '#002D55' }} />
      <Divider />
      <List style={{ marginLeft: isXl ? -5 : -8 }}>
        <ListItem style={{ minHeight: 56, margin: 0, paddingLeft: isXl ? 3 : 3, justifyContent: 'flex-start' }}>
          <IconButton
            onClick={open ? onClose : onOpen}
          >
            <MenuIcon style={{ fontSize: 'clamp(21px, 1.46vw, 28px)', color: '#002D55' }} />
          </IconButton>
        </ListItem>
        <MainListItems open={open} />
      </List>
      {showSecondaryList && (
        <>
          <Divider />
          <List style={{ marginLeft: isXl ? -5 : -8 }}>
            <SecondaryListItems open={open} />
          </List>
        </>
      )}
      <Divider style={{ marginTop: '6px', marginBottom: '6px' }} />
      <List style={{ marginLeft: isXl ? -5 : -8 }}>
        <Tooltip title="Logout" placement="right" disableHoverListener={open}>
          <ListItem button onClick={(event) => setLogoutAnchorEl(event.currentTarget)} style={{ color: '#002D55', backgroundColor: '#FFFFFF' }}>
            <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
              <VpnKeyIcon style={{ color: '#002D55', fontSize: 'clamp(20px, 1.25vw, 24px)' }} />
            </ListItemIcon>
            {open && <ListItemText primary="Logout" />}
          </ListItem>
        </Tooltip>
      </List>
      <Divider style={{ marginTop: '6px', marginBottom: '6px' }} />
      <Menu
        anchorEl={logoutAnchorEl}
        keepMounted
        open={Boolean(logoutAnchorEl)}
        onClose={() => setLogoutAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ style: { borderRadius: 14, minWidth: 'clamp(120px, 10vw, 160px)' } }}
      >
        <MenuItem onClick={() => { setLogoutAnchorEl(null); handleLogout(); }} style={{ fontSize: 'clamp(0.72rem, 0.8vw, 0.875rem)', padding: '6px 16px' }}>Logout</MenuItem>
      </Menu>
    </Drawer>
  );
}
